var _defs, _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSmallProjectsLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1024,
    height: 1024,
    viewBox: "0 0 1024 1024",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "small_bg",
    x1: 512,
    y1: 0,
    x2: 512,
    y2: 1024,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#313131"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#141414"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "small_glow",
    x: "-30%",
    y: "-30%",
    width: "160%",
    height: "160%"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 18,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "blur"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  }))))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1024,
    height: 1024,
    rx: 228,
    fill: "url(#small_bg)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#151515",
    strokeWidth: 9,
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "362,437 512,512 362,587 212,512",
    fill: "#8a6942"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "212,512 362,587 362,737 212,662",
    fill: "#6d5334"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "512,512 362,587 362,737 512,662",
    fill: "#54401f"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "662,437 812,512 662,587 512,512",
    fill: "#a8814f"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "512,512 662,587 662,737 512,662",
    fill: "#7f6140"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "812,512 662,587 662,737 812,662",
    fill: "#5f4926"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#small_glow)"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "362,265 512,340 362,415 212,340",
    fill: "#e6b866"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "212,340 362,415 362,565 212,490",
    fill: "#bd914b"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "512,340 362,415 362,565 512,490",
    fill: "#8f6c33"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmallProjectsLogo);
export default __webpack_public_path__ + "static/media/small-projects-logo.05db111208bab0b72acf6cca17424379.svg";
export { ForwardRef as ReactComponent };